var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-header"}},[_c('app-menu'),_c('order-loader'),_c('vk-icon',{staticClass:"icon-cart",attrs:{"icon":"cart","ratio":"2"},on:{"click":function($event){return _vm.$router.push({path:'/cart'})}}}),(_vm.stock_cart_count)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.stock_cart_count))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }